// extracted by mini-css-extract-plugin
export default {"default":"AppDark__default___DppGL"};